import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { GlobalMessageService, LoggerService, normalizeHttpError } from '@spartacus/core'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { EbCartAdapter } from '../services/connectors/eb-cart.adapter'

@Injectable({ providedIn: 'root' })
export class EbCartInterceptor implements HttpInterceptor {

  protected logger = inject(LoggerService);

  constructor(
    protected globalMessageService: GlobalMessageService,
    protected cartAdapter: EbCartAdapter
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((response: any) => {
        if (response instanceof HttpErrorResponse) {
          this.cartAdapter.showErrorMessage(normalizeHttpError(response, this.logger))
        }
        return throwError(() => response)
      })
    )
  }
}
